<template>
  <div>
    <table class="table table-sm mt-0 table-hover table-striped">
      <thead>
      <tr>
        <td v-if="useCheckBox"></td>
        <td width="80px">
          <i
            @click="sortOrders('id')"
            :class="{
            'icon-fa pointer': true,
            'icon-fa-sort-amount-asc': sortingData.id.direction === 'asc',
            'icon-fa-sort-amount-desc': sortingData.id.direction !== 'asc'
          }"></i>
          Номер
        </td>
        <td width="250px">Клиент</td>
        <td width="300px">Адрес</td>
        <td>Препараты</td>
        <td width="80px">
          <i
            @click="sortOrders('price')"
            :class="{
            'icon-fa pointer': true,
            'icon-fa-sort-amount-asc': sortingData.price.direction === 'asc',
            'icon-fa-sort-amount-desc': sortingData.price.direction !== 'asc'
          }"></i>
          Сумма
        </td>
        <td width="170px" v-if="type !== 'doneByManager'">Курьер</td>
        <th></th>
        <td width="100px">
          <i
            @click="sortOrders('deliveryDateTimeStamp')"
            :class="{
            'icon-fa pointer': true,
            'icon-fa-sort-amount-asc': sortingData.deliveryDateTimeStamp.direction === 'asc',
            'icon-fa-sort-amount-desc': sortingData.deliveryDateTimeStamp.direction !== 'asc'
          }"></i>
          Дата доставки
        </td>
      </tr>
      </thead>
      <tbody>
      <tr v-for="order in localOrders" :key="order.id" v-if="order.visible">
        <td v-if="useCheckBox">
          <input type="checkbox" v-model="selectedOrders[order.id]">
        </td>
        <td>
          {{ order.id }}
          <p><strong>{{ $AllProjects[order.site_id]?.title ?? order.site_id }}</strong>
            ({{ $AllCities[order.city_id] && $AllCities[order.city_id].short_name || order.city_id }})</p>
          <!--          <template v-if="showStoreData && order.is_agreed">-->
          <!--            <span class="badge badge-success">Согласовано</span>-->
          <!--          </template>-->
          <template
            v-if="(order.comment && order.comment.length) || order.reject_comment"
          >
            <i
              v-tooltip="{
                    content: getComments(order),
                    placement: 'bottom-center',
                    classes: ['info custom-tooltip'],
                    targetClasses: ['it-has-a-tooltip custom-tooltip'],
                    offset: 10,
                    delay: {
                      show: 200,
                      hide: 700
                    }
                  }"
              class="icon-fa icon-fa-info-circle comment_tooltip_fa"
            ></i>
          </template>
          {{ printDate(order.created_at, 'DD.MM.YYYY HH:mm') }}
        </td>
        <td>
          <p>{{ order.client_name }}</p>
          <p v-if="order.is_customer_trusted"><span
            class="badge badge-success">постоянный ({{ order.is_customer_trusted }})</span></p>
          <div v-for="(phone, pi) in order.order_phones">
            <div class="flex flex_gap_10">
              <MakeCall
                v-if="pi === 0 && phone.phone?.last_call && getTimeAgo(phone.phone?.last_call.created_at, order.delivery_date, true)"
                :phone="phone.phone" :order="order" :small="true"/>
              <span>{{ mixinPrintPhone(phone.phone.phone) }}</span>
            </div>
            <p v-if="phone.phone?.last_call">контакт
              <span v-html="getTimeAgo(phone.phone?.last_call.created_at, pi === 0 ? order.delivery_date : null)"/>
            </p>
          </div>
          <template v-if="order.extra_options?.noAnswerCallOrder">
            <span class="badge badge-warning">недозвонов: <strong>{{
                order.extra_options.noAnswerCallOrder
              }}</strong></span>
          </template>
          <AgreementButton
            v-if="order.status === 1"
            text="сменить дату"
            component="DeliveryDateChange"
            :order="order"
          />
        </td>
        <td>
          <div class="flex align-items-center">
            <v-popover v-if="order.address"
                       :auto-hide="true"
                       placement="right"
                       popoverClass="order_address_map_popover"
                       popoverInnerClass="order_address_map_popover_inner"
                       :delay='{ show: 500, hide: 500 }'
            >
              <button class="btn btn-xs btn-outline-info mr-1"><i
                class="icon-fa icon-fa-map-marker"/>
              </button>
              <template slot="popover">
                <AddressMap :orderId="order.id"/>
              </template>
            </v-popover>
            <span><strong>{{
                $AllCities[order.city_id] && $AllCities[order.city_id].name || order.city_id
              }}</strong></span>
          </div>
          <p>{{ order.address }}</p>
          <RunnerSalaryRate :rate="order?.extra_options?.salary_rate ?? 0"/>
        </td>
        <td>
          <div v-for="detail in order.details" :class="`drug_details ${getOrderClass(order, detail)}`">
            <p class="flex">
              {{ detail.new_drug && detail.new_drug.title }} ({{ detail.drug_id }})
              <span v-if="detail.new_drug && detail.new_drug.cool" class="ml-1"><i
                class="icon icon-snowflake"/></span>
              <i
                v-if="detail.new_drug && detail.new_drug.pack_comment"
                v-tooltip="{
                        content: detail.new_drug.pack_comment,
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        offset: 20,
                        delay: {
                          show: 500,
                          hide: 300
                        }
                      }"
                class="icon-fa icon-fa-info-circle ml-1"
              ></i>
              <i
                v-if="detail.new_drug && detail.new_drug.pack_box_comment"
                v-tooltip="{
                        content: detail.new_drug.pack_box_comment,
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        offset: 20,
                        delay: {
                          show: 500,
                          hide: 300
                        }
                      }"
                class="icon-fa icon-fa-info-circle ml-1"
              ></i>
            </p>
            <template v-if="detail.pack_set !== 1">
              <p><strong>x {{ detail.qty / detail.pack_set }}</strong> (компл)<strong> * {{
                  detail.price * detail.pack_set
                }}</strong></p>
              <p><strong>x {{ detail.qty }}</strong> завод. упак.<strong> * {{ detail.price }}</strong></p>
            </template>
            <template v-else>
              <p><strong>x {{ detail.qty }} * {{ detail.price }}</strong>
                <CurrencyDrugPrice v-if="division?.settings?.currency_id && division.settings.currency_id !== 33"
                                   :drugData="detail" :currency="$AllCurrencies[division.settings.currency_id]"/>
              </p>
            </template>
            <template v-if="showStoreData">
              <p>По согласованных или предоплаченных заявках:
                <i
                  v-tooltip="{
                        content: printDebugDrugData(detail.drug_id),
                        placement: 'bottom-center',
                        classes: ['info'],
                        autoHide: false,
                        targetClasses: ['it-has-a-tooltip'],
                        offset: -5,
                        delay: {
                          show: 500,
                          hide: 500
                        }
                      }"
                  class="icon-fa icon-fa-info-circle ml-1"
                ></i>
              </p>
              <p>без учета текущей заявки</p>
              <div>
                <span class="extra_store_block" v-for="(s, i) in [storeId,...motherRelatedStores]">
                  {{ $AllStores[s].short_title }} :
                  <strong>
                  <template v-if="i === 0">
                    {{ (dynamicStoreData.final[detail.drug_id]?.[s] ?? 0) + detail.qty }}
                  </template>
                    <template v-else>{{ dynamicStoreData.final[detail.drug_id]?.[s] ?? 0 }}</template>
                  </strong>
                </span>
              </div>
              <div v-if="appointedOrdersDrugs">
                Наличие - транизит - назначенные:
                <strong>{{
                    (dynamicStoreData.stage_1[detail.drug_id]?.[storeId] ?? 0) - (appointedOrdersDrugs[detail.drug_id] ??
                      0)
                  }}</strong>
              </div>
            </template>
          </div>
        </td>
        <td>
          <div class="flex">
            <div class="mr-2" v-if="sendMessageModal[order.id] && sendMessageModal[order.id].supervisor">
              <button class="btn btn-outline-info btn-xs" type="button"
                      @click="sendTelegramMessage(order.id, 'supervisorModal')">
                <i class="icon-fa icon-fa-user-secret"/>
              </button>
              <SendRunnerMessage
                v-if="sendMessageModal[order.id].supervisorModal"
                :data="order"
                type="supervisor"
                :onModalClose="() => sendMessageModal[order.id].supervisorModal = false"
              />
            </div>
            <div>
              <PrePaidInfo :order="order"/>
              <p>{{ order.price }}</p>
              <p v-if="order.currency_id && order.currency_id !== 33">{{ order.currency_id_price }}
                {{ $AllCurrencies[order.currency_id].currency }}</p>
            </div>
          </div>
          <div v-if="order.discount">
            Скидка: <strong>{{ order.discount }}</strong>{{ order.discount_type == 1 ? '%' : 'руб' }}
          </div>
        </td>
        <td v-if="type !== 'doneByManager'">
          <template v-if="order.courier">
            <p>{{ order.courier.name }}</p>
            <!--            <p>{{ order.courier.phone }}</p>-->
          </template>
          <div class=""
               v-if="type && type !== 'doneByManager' && sendMessageModal[order.id] && sendMessageModal[order.id].runner">
            <button class="btn btn-outline-info btn-xs" type="button"
                    @click="sendTelegramMessage(order.id, 'runnerModal')">
              <i class="icon-fa icon-fa-motorcycle"/>
            </button>
            <SendRunnerMessage
              v-if="sendMessageModal[order.id].runnerModal"
              :data="order"
              type="runner"
              :onModalClose="() => sendMessageModal[order.id].runnerModal = false"
            />
          </div>
        </td>
        <td>
          <template v-if="allowToShiftToPost && order.pay_method === 3">
            <LoadingButton
              title="На почту"
              type="button"
              :loading="postSendBtnLoading[order.id]"
              :color="$constants.PRIMARY_COLOR"
              :onClick="() => changeOrdersDivision(order.id)"
              className="btn btn-outline-info"
            />
          </template>
          <template v-if="storeId === 3 && allowToSendOrders">
            <LoadingButton
              title="На отправку"
              type="button"
              :loading="postSendBtnLoading[order.id]"
              :color="$constants.PRIMARY_COLOR"
              :onClick="() => sendToPostDelivery(order.id)"
              className="btn btn-outline-info"
            />
          </template>
        </td>
        <td>
          <p><span
            :class="{'badge badge-warning': getDeliveryDate(order).overdue}">{{ getDeliveryDate(order).date }}</span>
          </p>
          <template>
            <button
              @click="orderToEdit(order.id)"
              class="btn btn-xs btn-info pull-left mr-2"
            >
              <i class="icon-fa icon-fa-eye"></i>
            </button>
          </template>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from 'moment'
import SendRunnerMessage from '@/components/telegram/SendRunnerMessage'
import AgreementButton from '@/components/orders/Agreement/AgreementButton'
import StoreData from '@/components/drugs/StoreData'
import PrePaidInfo from "@/components/orders/prePaid/PrePaidInfo.vue";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";
import AddressMap from "@/components/map/AddressMap.vue";
import MakeCall from "@/components/orders/telephony/MakeCall.vue";
import CurrencyDrugPrice from "@/components/orders/ordersData/CurrencyDrugPrice.vue";
import RunnerSalaryRate from "@/views/orders/RunnerSalaryRate.vue";

export default {
  props: ['division', 'orders', 'useCheckBox', 'allowToShiftToPost', 'allowToSendByPost', 'appointedOrdersDrugs', 'motherRelatedStores', 'dynamicStoreData', 'allOrders', 'storeId', 'type', 'storeStatus', 'showStoreData', 'storeData', 'storeRequest', 'actualRequests', 'actualStore'],
  components: {
    RunnerSalaryRate,
    CurrencyDrugPrice,
    MakeCall,
    AddressMap,
    LoadingButton,
    PrePaidInfo,
    SendRunnerMessage,
    AgreementButton,
    StoreData,
  },
  computed: {
    $AllCurrencies() {
      return this.$store.getters['platform/currencies']
    },
    $AllStores() {
      return this.$store.getters['platform/stores']
    },
    $AllProjects() {
      const sites = this.$store.getters["platform/projects"].reduce(
        (acc, p) => {
          acc[p.id] = {...p};
          return acc;
        },
        {}
      );
      return sites;
    },
    $AllCities() {
      return this.$store.getters['platform/cities']
    },
    $AllDivisions() {
      return this.$store.getters['platform/divisions']
    },
    $StoresNotificationSettings() {
      return this.$store.getters['platform/storeNotificationSettings']
    },
  },
  watch: {
    orders: {
      handler: function (val, oldVal) {
        this.sortOrders()
      },
    }
  },
  created() {
    this.allowToSendOrders = this.allowToSendByPost && (this.$currentRole === 'admin' || this.$currentUserRoles.includes('postManager'));
    this.sortOrders()
    // this.sortOrders('deliveryDateTimeStamp')
  },
  data() {
    return {
      allowToSendOrders: false,
      sendMessageModal: {},
      localOrders: [],
      dynamicStore: {},
      selectedOrders: {},
      postSendBtnLoading: {},
      sortingData: {
        id: {sort: true, direction: 'asc'},
        price: {sort: false, direction: 'asc'},
        deliveryDateTimeStamp: {sort: false, direction: 'asc'},
      },
    }
  },
  methods: {
    getTimeAgo(time, compareDate = null, allowToCall = false) {
      const daysWithoutContact = 5;
      const daysBeforeDelivery = 7;

      const date = moment(time);
      const now = Date.now();
      const days = date.diff(now, 'days');

      if (days < 0) {
        if (compareDate && moment(compareDate).diff(now, 'days') >= daysBeforeDelivery && Math.abs(days) >= daysWithoutContact) {
          if (allowToCall) return true;
          return '<strong><span class="badge badge-danger fs-12">' + Math.abs(days) + ' дней назад</span></strong>';
        }
        // if (days > -5) {
        //   return '<span class="badge badge-warning fs-12">' + Math.abs(days) + ' дней назад</span>';
        // }
        if (compareDate && days <= -5) {
          if (allowToCall) return true;
          return '<strong><span class="badge badge-warning fs-12">' + Math.abs(days) + ' дней назад</span></strong>';
        }
        if (allowToCall) return false;
        return Math.abs(days) + ' дн. назад';
      }
      if (allowToCall) return false;
      const hours = date.diff(now, 'hours');
      if (hours < 0) {
        return Math.abs(hours) + ' час. назад';
      }
      const minutes = date.diff(now, 'minutes');
      if (minutes < 0) {
        return Math.abs(minutes) + ' мин. назад';
      }
      return '';
    },
    printDebugDrugData(drugId) {
      let html = '<p>STAGE 1</p>';
      html += `<p>${JSON.stringify(this.dynamicStoreData.stage_1[drugId])}</p>`;
      html += '<p>STAGE 2</p>';
      html += `<p>${JSON.stringify(this.dynamicStoreData.stage_2[drugId])}</p>`;
      html += '<p>STAGE 3</p>';
      html += `<p>${JSON.stringify(this.dynamicStoreData.final[drugId])}</p>`;
      return html;
    },
    async changeOrdersDivision(orderId) {
      this.postSendBtnLoading[orderId] = true;
      this.postSendBtnLoading = {...this.postSendBtnLoading};
      const {data} = await api.post('/orders/updateOrderByAction', {
        action: 'changeDivisionToPost',
        order_id: orderId,
      })
      if (data.success) {
        const index = this.localOrders.findIndex((o) => o.id === orderId);
        this.localOrders[index].visible = false;
        toastr['success']('Отправлено');
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.postSendBtnLoading[orderId] = false;
    },
    async sendToPostDelivery(orderId, reject = false) {
      const order = this.allOrders.find((o) => o.id === +orderId);
      if (!order) {
        toastr['warning']('Заявка не найдена в списке', 'Ошибка');
        return;
      }
      if (order.city_id) {
        toastr['warning']('Заявка имеет город доставки и не может быть отправлена почтой', 'Ошибка');
        return;
      }
      this.postSendBtnLoading[orderId] = true;
      this.postSendBtnLoading = {...this.postSendBtnLoading};
      const {data} = await api.post('/tasks/new', {
        type: 'sendOrderByPost',
        orderId
      })
      if (data.success) {
        toastr['success']('Отправлено');
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.postSendBtnLoading[orderId] = false;
    },
    sendTelegramMessage(orderId, type) {
      this.sendMessageModal[orderId][type] = true
    },
    sortOrders(type = null) {
      console.log('update orders!')
      // const storeData = {...this.storeData.actualStoreData};
      if (type) {
        console.log('sorting');
        Object.keys(this.sortingData).forEach((t) => {
          if (t !== type) {
            this.sortingData[t].sort = false;
          }
        })
        this.sortingData[type].direction = this.sortingData[type].direction === 'asc' ? 'desc' : 'asc';
        switch (type) {
          case 'price':
          case 'deliveryDateTimeStamp':
            this.localOrders = _.orderBy(this.localOrders, type, this.sortingData[type].direction)
            break;
          default:
            this.localOrders = [..._.orderBy(this.localOrders.filter((o) => o.allowToDelivery), type, this.sortingData[type].direction), ..._.orderBy(this.localOrders.filter((o) => !o.allowToDelivery), type, this.sortingData[type].direction)];
            break;
        }
        return;
      }
      if (this.showStoreData) {
        const dynamicStore = {};
        (this.allOrders || this.orders).forEach((o) => {
          o.details.forEach((d) => {
            if (dynamicStore[d.drug_id] === undefined) {
              dynamicStore[d.drug_id] = this.storeData?.actualStoreData?.[d.drug_id] && this.storeData.actualStoreData[d.drug_id][this.storeId] || 0;
            }
            if (o.extra_options.callDeal) {
              dynamicStore[d.drug_id] -= d.qty
            }
          })
        })
        this.dynamicStore = {...dynamicStore};
      }

      const sendMessageModal = {}
      const citiesToStores = Object.values(this.$AllDivisions).reduce((acc, d) => {
        d.cities.forEach((c) => {
          acc[c.object_id] = d.stores[0].object_id
        })
        return acc
      }, {})
      this.orders.forEach(o => {
        sendMessageModal[o.id] = {
          runner: this.$StoresNotificationSettings[citiesToStores[o.city_id]] && this.$StoresNotificationSettings[citiesToStores[o.city_id]].runner[o.status] && this.$StoresNotificationSettings[citiesToStores[o.city_id]].runner[o.status] > 0,
          supervisor: this.$StoresNotificationSettings[citiesToStores[o.city_id]] && this.$StoresNotificationSettings[citiesToStores[o.city_id]].supervisor[o.status] && this.$StoresNotificationSettings[citiesToStores[o.city_id]].supervisor[o.status] > 0,
          runnerModal: false,
          supervisorModal: false,
        }
      })
      this.sendMessageModal = {...sendMessageModal}

      if (this.orders[0]) {
        const orders = this.orders.map((o) => {
          // o.is_available_to_agree = this.getOrderClass(o, {},true)
          if (o.visible === undefined) {
            o.visible = true;
          }
          o.deliveryDateTimeStamp = moment(o.delivery_date).unix();
          o.allowToDelivery = o.details.reduce((acc, d) => {
            if ((this.dynamicStoreData.final?.[d.drug_id]?.[o.store_id] ?? 0) < 0) {
              acc = false;
            }
            return acc;
          }, true);
          return {...o}
        })
        // this.localOrders = _.orderBy(orders, 'is_available_to_agree');
        this.localOrders = _.orderBy(orders, 'deliveryDateTimeStamp');
        // this.localOrders = [...(this.orders[0].report_date ? _.orderBy(this.orders, 'report_date') : _.orderBy(this.orders, 'delivery_date'))]
      }
    },
    getOrderClass(order, detail, index = false) {
      return `drugs_status_${this.storeStatus?.[order.id]?.status}`;
      const storeQty = (this.dynamicStoreData.final?.[detail.drug_id]?.[order.store_id] ?? 0);
      const inStore1 = (this.dynamicStoreData.stage_1?.[detail.drug_id]?.[order.store_id] ?? 0);
      console.log(order.id, storeQty, inStore1, this.storeStatus[order.id]);
      if (inStore1 > 0) {
        if (storeQty < 0 && (storeQty + detail.qty) <= 0) {
          return 'drugs_status_2';
        }
      }
      if (storeQty < 0) return 'drugs_status_1';
      return;
    },
    orderToEdit(id) {
      this.$store.dispatch('orders/setOrderToEdit', {orderId: id})
    },
    isOrderInDynamicStore(order) {
      return order.is_agreed || order.pay_method === 3;
    },
    moment(date, format = 'DD.MM.YYYY') {
      return moment(date).format(format)
    },
    getDeliveryDate(order) {
      const date = order.delivery_date || order.report_date;
      return {
        date: moment(date).format('DD.MM.YYYY'),
        overdue: moment() > moment(date)
      }
    },
    getComments(order) {
      let html = ''
      if (order.comment) {
        order.comment.forEach(c => {
          html +=
            '<div><p><small>' +
            c.created_at +
            '</small></p><p><strong>' +
            (c.user_name || 'Система') +
            '</strong> ' +
            c.text +
            '</p></div>'
        })
      }
      if (order.extra_options.comments_for_runner && order.extra_options.comments_for_runner.length) {
        html += '<div><p>Для курьера</p></div>'
        order.extra_options.comments_for_runner.forEach(c => {
          html +=
            '<div><p><small>' +
            c.created_at +
            '</small></p><p><strong>' +
            (c.user_name || 'Система') +
            '</strong> ' +
            c.text +
            '</p></div>'
        })
      }
      if (order.status < 0 && order.reject_comment) {
        html +=
          '<div><p><small>Причина отказа</small></p><p>' +
          order.reject_comment +
          '</p>'
      }
      return html
    },
  }
}
</script>

<style>
.drug_details .it-has-a-tooltip {
  display: inline-block;
  /*vertical-align: -webkit-baseline-middle;*/
  /*width: 17px;*/
  /*height: 19px;*/
  color: #5BBFDE;
  /*margin: 0 auto;*/
  cursor: pointer;
  font-size: 20px;
}

.comment_tooltip_fa {
  font-size: 20px;
  color: #5bbfde;
  cursor: pointer;
}

.tooltip.info.custom-tooltip .tooltip-inner {
  background: rgba(91, 191, 222, 1);
  padding: 12px;
  max-width: 450px;
  text-align: left;
}

.tooltip.info.custom-tooltip .tooltip-inner div {
  margin-bottom: 10px;
}

.tooltip.info.custom-tooltip .tooltip-inner p {
  margin-bottom: 0px;
}
</style>

<style scoped>
.fs-14 {
  font-size: 14px;
}

i {
  text-align: center;
}

.drug_details hr {
  margin: 2px 0;
}

.chat_icon {
  cursor: pointer;
  color: #5bbfde;
}

.chat_btn i {
  font-size: 17px;
}

.icon-snowflake {
  display: inline-block;
  /*vertical-align: -webkit-baseline-middle;*/
  height: 16px;
  width: 14px;
  background: #5BBFDE;
  /*margin: 0 auto;*/
  margin-top: 2px;
  mask: url(/assets/svg/snowflake-solid.svg);
}

p {
  margin-bottom: 2px;
}

.drugs_status_1 {
  background-color: #ffe8e8;
}

.drugs_status_2 {
  background-color: #fff6de;
}

.extra_store_block {
  padding: 0 5px;
  border: 2px solid lightgray;
}

.drugs_status_3 {
  background-color: #bce2f4;
}
</style>
